import { Component } from '../jsti/core';
import Notifications from '../constants/Notifications';
import EventNames from '../constants/EventNames';

export default class SubscriptionFrequency extends Component {
  frequency = null;
  errorMessage = null;

  bind(el: HTMLElement): void {
    super.bind(el);
    this.frequency = this.el.getElementByRef('subscription-frequency');
    this.errorMessage = this.el.getElementByRef('error-message');
    this.addListener(Notifications.SUBSCRIPTION_PERIOD_ADD_REQUIRED_MESSAGE, this.addRequiredMessage);
    this.frequency.addEventListener(EventNames.CHANGE, this.removeRequiredMessage.bind(this));
  }

  addRequiredMessage() {
    this.errorMessage.classList.remove('hidden');
    this.frequency.classList.add('border', 'border-red');

    this.el.parentElement.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  }

  removeRequiredMessage() {
    this.frequency.classList.remove('border', 'border-red');
    this.errorMessage.classList.add('hidden');
  }
}
